export default __webpack_public_path__ + "static/media/bank-applepay.329c938b.svg";